<template src="./form.html"></template>

<script>
import { UpdateDomain, ViewDomain } from '@/api/domain'

export default {
  name: 'edit-domain',
  data: function () {
    return {
      model: {
        id: '',
        domain: '',
        label: null,
        instructions: null,
        note: null,
        repeated: null
      },
      loading: false,
      ruleValidate: {
        domain: [{
          required: true,
          message: '表单名称不能为空',
          trigger: 'change'
        }],
        label: [{
          required: true,
          message: '表单标签不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  props: ['meta'],
  methods: {
    init: function (id) {
      ViewDomain(id).then(async res => {
        this.model = res
      })
    },
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        } else {
          this.$Message.error('信息填写有误!')
        }
      })
    },
    postForm: function () {
      UpdateDomain(this.model).then(async res => {
        if (res.id) {
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>
